'use client';

import type { FC, ReactNode, SyntheticEvent } from 'react';
import { ClickableDiv } from '@wwe-portal/ui/components/button';

export const FlagshipMobileCardLayout: FC<{
  items: ReactNode;
  quantity: ReactNode;
  background: ReactNode;
  title: ReactNode;
  price: ReactNode;
  overlay: ReactNode;
  onClick?: (e: SyntheticEvent) => void;
}> = ({ background, title, items, quantity, price, overlay, onClick }) => {
  return (
    <div className="block h-full w-full pt-[18px] md:hidden">
      <ClickableDiv
        className="font-poppins relative h-[259px] rounded-b-[calc(600%/108)]"
        onClick={onClick}
      >
        <div className="absolute inset-0 overflow-hidden">{background}</div>
        <div className="absolute inset-0 bg-black opacity-40" />
        {items}
        <div className="absolute bottom-0 left-0 right-0 h-full">
          <div className="item-stretch flex h-full flex-col justify-end">
            <div className="relative flex justify-center bg-[#124980] px-2 text-center">
              {title}
              {quantity}
            </div>
            {price}
          </div>
          <div className="pointer-events-none absolute inset-0 rounded-b-[6px] border border-solid border-[#FF7B00]" />
          {overlay}
        </div>
      </ClickableDiv>
    </div>
  );
};

export interface FlagshipDesktopCardLayoutProps {
  content: ReactNode;
  footer: ReactNode;
  items: ReactNode;
  overlay: ReactNode;
  backgroundImage?: string;
  onClick?: (e: SyntheticEvent) => void;
}

export const FlagshipDesktopCardLayout: FC<FlagshipDesktopCardLayoutProps> = ({
  content,
  items,
  backgroundImage,
  footer,
  overlay,
  onClick,
}) => {
  return (
    <div className="relative hidden h-full w-full select-none md:block">
      <ClickableDiv
        className="font-poppins bg-back400 flex h-[321px] w-full flex-row gap-0 border-none"
        onClick={onClick}
      >
        <div className="w-1/2 flex-shrink-0 flex-grow-0 gap-4 px-10">
          {content}
        </div>
        <div
          className="relative flex w-1/2 flex-shrink-0 flex-grow-0 bg-right"
          style={
            backgroundImage
              ? {
                  backgroundImage: `url("${backgroundImage}")`,
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                }
              : undefined
          }
        >
          {items}
        </div>
      </ClickableDiv>
      {footer != null ? (
        <div className="bg-back300 flex h-[81px] w-full items-center">
          {footer}
        </div>
      ) : null}
      {overlay}
    </div>
  );
};
